import $ from 'jquery';
import { bootManageCollaboratorsContainer } from '@/lib/components/ListActions/ManageCollaboratorsProvider';
import EntriesList from './components/EntriesList';
import { Popover } from 'vue-bootstrap';
import store from '@/lib/store';
import Vue from 'vue';

export default function () {
	bootManageCollaboratorsContainer();

	const entriesList = new Vue({
		el: '#entries-list',
		name: 'ManageEntriesApp',
		components: {
			EntriesList,
			Popover,
		},
		store,
	});

	$(document).one('pjax:end', () => {
		entriesList.$destroy();
	});
}
